class CustomSlider {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.sliderId = wrapper.dataset.sliderId;
    this.effect = wrapper.dataset.sliderEffect;
    this.slider = wrapper.querySelector('.custom-slider');
    this.slides = wrapper.querySelectorAll('.custom-slide');
    this.prevButton = wrapper.querySelector('.prev-slide');
    this.nextButton = wrapper.querySelector('.next-slide');
    this.currentSlide = 0;
    this.autoPlayInterval = null;
    this.autoPlaySpeed = parseInt(wrapper.dataset.sliderSpeed) || 5000;

    this.init();
  }

  init() {
    if (this.slides.length > 1) {
      this.setupSlider();
      this.bindEvents();
      this.showSlide(this.currentSlide);
      this.startAutoPlay();
    } else {
      this.hideNavigation();
    }
  }

  setupSlider() {
    this.slider.style.position = 'relative';
    
    const firstImage = this.slides[0].querySelector('img');
    
    if (firstImage) {
      firstImage.onload = () => {
        const aspectRatio = firstImage.naturalHeight / firstImage.naturalWidth;
        this.slider.style.paddingBottom = `${aspectRatio * 100}%`;
      };
    }

    this.slides.forEach((slide, index) => {
      slide.style.position = 'absolute';
      slide.style.top = '0';
      slide.style.left = '0';
      slide.style.width = '100%';
      slide.style.height = '100%';
      slide.style.opacity = index === this.currentSlide ? '1' : '0';
      slide.style.transition = 'opacity 0.5s ease-in-out';
    });
  }

  bindEvents() {
    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', () => {
        this.prevSlide();
        this.stopAutoPlay();
        this.startAutoPlay();
      });
      this.nextButton.addEventListener('click', () => {
        this.nextSlide();
        this.stopAutoPlay();
        this.startAutoPlay();
      });
    }

    this.wrapper.addEventListener('mouseenter', () => this.stopAutoPlay());
    this.wrapper.addEventListener('mouseleave', () => this.startAutoPlay());
  }

  showSlide(index) {
    this.slides.forEach((slide, i) => {
      if (i === index) {
        slide.style.opacity = '1';
        slide.style.zIndex = '1';
      } else {
        slide.style.opacity = '0';
        slide.style.zIndex = '0';
      }
    });
  }

  prevSlide() {
    this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.showSlide(this.currentSlide);
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.showSlide(this.currentSlide);
  }

  hideNavigation() {
    if (this.prevButton) this.prevButton.style.display = 'none';
    if (this.nextButton) this.nextButton.style.display = 'none';
  }

  startAutoPlay() {
    this.autoPlayInterval = setInterval(() => this.nextSlide(), this.autoPlaySpeed);
  }

  stopAutoPlay() {
    clearInterval(this.autoPlayInterval);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sliderWrappers = document.querySelectorAll('.custom-slider-wrapper');
  sliderWrappers.forEach(wrapper => new CustomSlider(wrapper));
});